import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class ArsaAraziM2BirimDegeriSorgulamaAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "ArsaArazim2BirimFiyatListe";
        super(baseUrl);
    }

    getArsaAraziM2BirimDegeriSorgulama(yili?: number, mahalleKodu?: number, caddeSokakKodu?: number, tipi?: number) {

        return this.get("", { params: { yili: yili, mahalleKodu: mahalleKodu, caddeSokakKodu: caddeSokakKodu, tipi: tipi } });
    }
}
export default new ArsaAraziM2BirimDegeriSorgulamaAPI();